export default function isHtml(str) {
  return /<\/?[a-z][\s\S]*>/i.test(str);
}
